import React, { ReactElement } from 'react';
import './LocationDetailTasksTile.scss';

interface LocationDetailTasksTileProps {
    /**
     * The breakdown group the tasks belong to, e.g. "Construction". Undefined whenever the
     * sidebar was opened from a plain location row, which is the only state this story
     * renders — the task cards themselves arrive with the query in a later story.
     */
    groupName?: string;
}

const LocationDetailTasksTile = ({ groupName }: LocationDetailTasksTileProps): ReactElement => (
    <div className='location-detail-tasks-tile'>
        <div className='location-detail-tasks-tile-empty'>
            {groupName
                ? `No tasks to show for ${groupName}`
                : 'No tasks selected'}
        </div>
    </div>
);

export default LocationDetailTasksTile;
